<template>
  <div>
  </div>
</template>

<script>
import { highlighter } from '@nlux/highlighter';
import { ElMessage } from 'element-plus';

export default {
  name: "ChatBot",
  mounted() {
    // Load external scripts
    const chatbotScript = document.createElement("script");
    chatbotScript.type = "module";
    chatbotScript.crossOrigin = "anonymous";
    chatbotScript.src = "https://g.alicdn.com/aliyun-documentation/web-chatbot-ui/0.0.24/index.js";
    document.body.appendChild(chatbotScript);

    const chatbotCss = document.createElement("link");
    chatbotCss.rel = "stylesheet";
    chatbotCss.crossOrigin = "anonymous";
    chatbotCss.href = "https://g.alicdn.com/aliyun-documentation/web-chatbot-ui/0.0.24/index.css";
    document.head.appendChild(chatbotCss);

    const checkBubble = setInterval(() => {
      const bubble = document.querySelector('.webchat-bubble-tip');
      if (bubble) {
        clearInterval(checkBubble);
        this.transformBubble(bubble);
      }
    }, 100);
    this.setupCodeCopyButtons();
    window.CHATBOT_CONFIG = {
      endpoint: "/chat",
      displayByDefault: this.$route.path === '/help' && this.$route.query.openChat === 'true',
      title: '键鼠自动化AI 助手',
      draggable: true,
      aiChatOptions: {
        conversationOptions: {
          conversationStarters: [
            { prompt: '键鼠自动化都能做什么?' },
            { prompt: '我想模拟按键，应该怎么做?' },
            { prompt: '我想找图，应该怎么做?' }
          ]
        },
        displayOptions: {
          height: 550,
          width: 400
        },
        personaOptions: {
          assistant: {
            name: '你好，我是你的 AI 助手',
            avatar: 'https://img.alicdn.com/imgextra/i2/O1CN01Pda9nq1YDV0mnZ31H_!!6000000003025-54-tps-120-120.apng',
            tagline: '您可以尝试点击下方的快捷入口开启体验！'
          }
        },
        messageOptions: {
          syntaxHighlighter: highlighter,
          waitTimeBeforeStreamCompletion: 'never'
        }
      },
      dataProcessor: {
        rewritePrompt(prompt) {
          return prompt;
        }
      }
    };
  },
  methods: {
    transformBubble(bubble) {
      bubble.style.backgroundImage = 'none';

      bubble.style.width = '40px';
      bubble.style.height = '120px';
      bubble.style.borderRadius = '50px';
      bubble.style.backgroundColor = '#ffffff';
      bubble.style.display = 'flex';
      bubble.style.flexDirection = 'column';
      bubble.style.alignItems = 'center';
      bubble.style.justifyContent = 'center';
      bubble.style.padding = '10px';
      bubble.style.boxSizing = 'border-box';
      bubble.style.cursor = 'pointer';

      const img = document.createElement('img');
      img.src = 'https://img.alicdn.com/imgextra/i2/O1CN01Pda9nq1YDV0mnZ31H_!!6000000003025-54-tps-120-120.apng';
      img.style.width = '26px';
      img.style.height = '40px';
      img.style.objectFit = 'cover';
      img.style.marginBottom = '10px';

      const text = document.createElement('div');
      text.textContent = 'AI 助理';
      text.style.fontSize = '12px';
      text.style.textAlign = 'center';
      text.style.fontWeight = 'bold';
      text.style.lineHeight = "20px"

      bubble.innerHTML = '';
      bubble.appendChild(img);
      bubble.appendChild(text);
    },
    setupCodeCopyButtons() {
      const setupCopyButton = (codeBlockContainer) => {
        const copyButton = codeBlockContainer.querySelector('.nlux-comp-copyButton');
        const preElement = codeBlockContainer.querySelector('pre');

        if (!copyButton || !preElement) return;
        if (copyButton.dataset.clickListenerSet === 'true') return;

        copyButton.addEventListener('click', () => {
          const textToCopy = preElement.innerText || preElement.textContent;

          // 尝试使用 `document.execCommand('copy')`（兼容 HTTP）
          const textArea = document.createElement('textarea');
          textArea.value = textToCopy;
          textArea.style.position = 'fixed';
          textArea.style.opacity = 0;
          document.body.appendChild(textArea);
          textArea.select();

          try {
            const success = document.execCommand('copy');
            if (success) {
              copyButton.innerHTML = '<span class="icon-check"></span>';
              copyButton.setAttribute('title', '已复制!');
              ElMessage.success('复制成功');

              setTimeout(() => {
                copyButton.innerHTML = '<span class="icon-copy"></span>';
                copyButton.setAttribute('title', '复制到剪贴板');
              }, 20);
            } else {
              ElMessage.error('复制失败，请手动选择文本后按 Ctrl+C');
            }
          } catch (err) {
            ElMessage.error('复制失败: ' + err.message);
          } finally {
            document.body.removeChild(textArea);
          }
        });

        copyButton.dataset.clickListenerSet = 'true';
      };

      // 监听动态加载的代码块
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.classList.contains('code-block')) {
              setupCopyButton(node);
            }
          });
        });
      });

      // 初始化现有的代码块
      document.querySelectorAll('.code-block').forEach(block => {
        setupCopyButton(block);
      });

      // 开始观察 DOM 变化
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

  }
};
</script>

<style>
.webchat-container {
  z-index: 1000;
  bottom: 10px;
  right: 10px;
}

.webchat-bubble-tip {
  z-index: 1000;
  bottom: 20px;
  right: 20px;
}

#webChat-dialog {
  bottom: 20px !important;

}

#webChat-bubble-tip {
  bottom: 20px !important;
  box-shadow: 0 0 11px -6px rgb(217 37 210);
}

.nlux-comp-chatItem.nlux-comp-chatItem--bubblesLayout.nlux-comp-chatItem--received {
  flex-direction: row;
  padding-right: 14px !important;
}

@media (max-width: 768px) {
  .webchat-container {
    position: fixed;
    transform: translate(16%, 0%);
  }

  #webChat-dialog {
    bottom: 0 !important;
    right: 60px !important;
    left: -64px !important;
    height: 100% !important;
    width: 100% !important;
  }

  .nlux-AiChat-root {
    min-width: 280px;
    min-height: 280px;
    width: 100vw !important;
    height: 92vh !important;
  }
}
</style>
